import { render, staticRenderFns } from "./TabDatosOrganos.vue?vue&type=template&id=032dcd1b&scoped=true"
import script from "./TabDatosOrganos.vue?vue&type=script&lang=js"
export * from "./TabDatosOrganos.vue?vue&type=script&lang=js"
import style0 from "./TabDatosOrganos.vue?vue&type=style&index=0&id=032dcd1b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032dcd1b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('032dcd1b')) {
      api.createRecord('032dcd1b', component.options)
    } else {
      api.reload('032dcd1b', component.options)
    }
    module.hot.accept("./TabDatosOrganos.vue?vue&type=template&id=032dcd1b&scoped=true", function () {
      api.rerender('032dcd1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/constitucionsociedades/TabDatosOrganos.vue"
export default component.exports